var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout-top-nav"},[_c('icon-svg'),_c('div',{staticClass:"wrapper"},[_c('navbar'),_c('Body'),_c('Footer')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }